if (
  typeof Array !== undefined
  && Array.prototype
  && !Array.prototype.moveByIndex
) {
  Object.defineProperty(Array.prototype, 'moveByIndex', {
    value(index, offset) {
      const newIndex = index + offset;
      if (newIndex > -1 && newIndex < this.length) this.splice(newIndex, 0, this.splice(index, 1)[0]);
      return this;
    }
  });
}